var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconOrderCancelled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#B6BCD1",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7 0c3.866 0 7 3.134 7 7s-3.134 7-7 7-7-3.134-7-7 3.134-7 7-7zM4.11 4.11c-.147.146-.147.384 0 .53L6.47 7 4.11 9.36c-.147.146-.147.384 0 .53.073.073.17.11.265.11.096 0 .192-.037.266-.11L7 7.53l2.358 2.36c.074.073.17.11.266.11s.192-.037.265-.11c.147-.146.147-.384 0-.53L7.53 7l2.36-2.36c.147-.146.147-.384 0-.53-.147-.147-.384-.147-.53 0L7 6.47 4.64 4.11c-.146-.147-.383-.147-.53 0z",
    transform: "translate(-116 -224) translate(24 208) translate(92 16)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOrderCancelled);
export default __webpack_public_path__ + "static/media/icon-order-cancelled.50f368e7b1cad6f0f2d11eba93271e8b.svg";
export { ForwardRef as ReactComponent };